$(document).ready(function () {
    $(document)
        .off('click.passwordToggle', '.input-password button')
        .on('click.passwordToggle', '.input-password button', function (event) {
            event.preventDefault();

            const input = $(this).siblings('input');
            const type = input.attr('type') === 'password' ? 'text' : 'password';

            input.attr('type', type);
            $(this).find('i').toggleClass('bi-eye bi-eye-slash');
    });
});